import ClientDashboard from './ClientDashboard';

export default ClientDashboard;
